<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <div class="company_name">SUPER TECH PTE LTD</div>
                    </div>
                </div>
            </div>
            <div v-if="seen" class="switch_language_container" @click="languageSwitch()">
                <div class="switch_language_btn">
                    <div>{{language == 'en' ? '中文':'English'}}</div>
                    <img :src="uri_icon_lang_switch" style="width: 16px;height: 16px;border: 0;margin-left: 15px;"/>
                </div>
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu v-if="seen" :default-active="activeIndex" active-text-color="#1C5DDD" class="el-menu-demo" menu-trigger="click" text-color="#000000" style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item style="height: 100%;" index="1" class="header-title">{{language == 'en' ? 'Company profile':'公司简介'}}</el-menu-item>
                    <el-menu-item style="height: 100%;" index="3" class="header-title">{{language == 'en' ? 'Product center':'产品中心'}}</el-menu-item>
                    <el-menu-item style="height: 100%;" index="4" class="header-title">{{language == 'en' ? 'News update':'新闻动态'}}</el-menu-item>
                    <el-menu-item style="height: 100%;" index="5" class="header-title">{{language == 'en' ? 'Service and support':'服务与支持'}}</el-menu-item>
                    <el-menu-item style="height: 100%;" index="6" class="header-title">{{language == 'en' ? 'About us':'关于我们'}}</el-menu-item>
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-menu v-if="!seen" :default-active="activeIndex" active-text-color="#1C5DDD" class="el-menu-demo" menu-trigger="click" text-color="#000000" style="height: 65px; border:0;" mode="horizontal" @select="handleSelectMobile">
                    <el-submenu index="1" class="header-title mobile_menu">
                        <el-menu-item index="1" class="header-title">{{language == 'en' ? '':'公司简介'}}</el-menu-item>
                        <el-menu-item index="3" class="header-title">{{language == 'en' ? '':'产品中心'}}</el-menu-item>
                        <el-menu-item index="4" class="header-title">{{language == 'en' ? '':'新闻动态'}}</el-menu-item>
                        <el-menu-item index="5" class="header-title">{{language == 'en' ? '':'服务与支持'}}</el-menu-item>
                        <el-menu-item index="6" class="header-title">{{language == 'en' ? '':'关于我们'}}</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <div class="container_v">
            <div class="footer_contaner_business">
                <div class="footer_business">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <div class="footer_business_item_container">
                                <div class="footer_business_item">
                                    <p class="footer_business_item_label">{{language == 'en' ? 'CONTACT NUMBER':'联系电话'}}</p>
                                    <div class="container_h align_center m_t_20">
                                        <img :src="uri_icon_index_business_phone" style="width: 34px;height: 34px;border: 0;margin-right: 15px;"/>
                                        <div class="footer_business_item_content">+86 16710636688（{{language == 'en' ? 'Hu Fei':'胡飞'}}）</div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <div class="footer_business_item_container" style="flex-direction: row-reverse;">
                                <div class="footer_business_item">
                                    <p class="footer_business_item_label">{{language == 'en' ? 'MAILBOX':'邮箱'}}</p>
                                    <div class="container_h align_center m_t_20">
                                        <img :src="uri_icon_index_business_email" style="width: 34px;height: 34px;border: 0;margin-right: 15px;"/>
                                        <div class="footer_business_item_content">liweiwei@supertechpte.com</div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="footer_copyright"></div>
            </div>
            <div class="footer_contaner_copyright">
                <div class="footer_copyright">{{language == 'en' ? 'Copyright 2008-2015. All Rights reserved':'版权所有：北京民商 京ICP备2023008340'}}</div>
            </div>
        </div>
        
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <img src="../assets/icon_to_top.png" style="height: 50px;width: 50px" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                language: 'en',
                uri_icon_lang_switch: require("../../static/index/icon_index_language_switch.png"),
                uri_icon_index_business_phone: require("../../static/index/icon_index_business_phone.png"),
                uri_icon_index_business_email: require("../../static/index/icon_index_business_email.png"),
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页'
            };
        },
        created() {
            this.language = sessionStorage.getItem('language');
            sessionStorage.setItem('language', '');
            if (this.language == null || this.language == '') {
                this.language = 'en';
            }
        },
        methods: {
            languageSwitch() {
                if (this.language == 'en') {
                    this.language = 'ch';
                    this.$router.push({name: "Index"});
                } else {
                    this.language = 'en';
                    this.$router.push({name: "IndexE"});
                }
            },
            handleSelect() {
                if (this.language == 'ch') {
                    this.$router.push({name: "Index"});
                } else {
                    this.$router.push({name: "IndexE"});
                }
            },
            handleSelectMobile() {
                if (this.language == 'ch') {
                    this.$router.push({name: "Index"});
                } else {
                    this.$router.push({name: "IndexE"});
                }
            },
            handleScroll() {
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                if (this.scroll > 600) {  //判断滚动后高度超过600px,就显示
                    this.$refs.btn.style.display = 'block';
                } else {
                    this.$refs.btn.style.display = 'none';
                }
            },
            backTop() {
                // 设置滚动行为改为平滑的滚动
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
            menuSeen() {
                // 屏幕尺寸
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    this.seen = true;
                } else {
                    this.seen = false;
                }
            },
            logoClick() {
                this.$router.push({name: "IndexE"});
                this.language = 'en';
            }
        },
        mounted() {
            this.menuSeen();
            window.addEventListener('scroll', this.handleScroll);
        },
    }
</script>

<style scoped>
    .logo_img{
        float:left;
        width: auto;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
        font-weight: bold;
    }
    .company_name{
        font-weight: bold;
        font-size: 1.3em;
        color: #1C5DDD;
    }
    .theme_blue {
        color: #1C5DDD;
    }
    .footer_font{
        font-size: 1em;
    }
    #menu_index{
        float: right;
        height: 100%;
        margin-right: 50px;
    }
    .header{
        margin: auto;
        width: 90%;
        height: 65px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}

    .container_v {
        display: flex;
        flex-direction: column;
    }
    .container_h {
        display: flex;
        flex-direction: row;
    }
    .justify_center {
        justify-content: center;
    }

    .align_center {
        align-items: center;
    }
    .m_t_20 {
        margin-top: 20px;
    }
    .switch_language_container {
        float: right;
        display: flex;
        align-items: center;
        height: 100%;
    }
    .switch_language_btn:hover {
        display: flex;
        align-items: center;
        height: 38px;
        color:white;
        background-color: #4775d1;
        border-radius: 5px;
        padding-left: 20px;
        padding-right: 20px;
        cursor: default;
    }
    .switch_language_btn {
        display: flex;
        align-items: center;
        height: 38px;
        color:white;
        background-color: #1C5DDD;
        border-radius: 5px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .footer_contaner_business {
        width: 100%;
        background-color: #1C5DDD;
        color: white;
    }
    .footer_business {
        width: 70%;
        margin: 20px auto;
        height: 80px;
    }
    .footer_contaner_copyright {
        width: 100%;
        background-color: #02185B;
        color: white;
    }
    .footer_copyright {
        width: 70%;
        margin: 20px auto;
        height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 0.25em;
        letter-spacing: 3px;
    }
    .footer_business_item_container {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
    }
    .footer_business_item {
        display: flex;
        flex-direction: column;
    }
    .footer_business_item_label {
        font-size: 0.25em;
        letter-spacing: 3px;
    }
    .footer_business_item_content {
        font-size: 1.25em;
        letter-spacing: 3px;
    }
</style>